<div class="text-center" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="32px">
  <section fxLayout fxLayoutAlign="start center" fxLayoutGap="9px">
    <svg
      class="platform-logo"
      width="24"
      height="24"
      viewBox="-3 -2 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      *ngIf="platform === 'homeaway'">
      <path
        d="M6.8443 11.6924L7.20602 10.9272L5.5803 3.01935C5.27547 1.48499 5.40553 0.687282 5.91357 0.231451V0.207031H5.03568C4.76744 0.78089 4.68615 1.35475 4.99504 2.87283L6.8443 11.6924ZM6.09646 13.2186L6.45819 12.4616L4.42603 2.85248C4.06837 1.35882 4.14966 0.675072 4.29597 0.207031H3.51969C3.51159 1.01521 3.61554 1.82059 3.82858 2.60015L6.09646 13.2186ZM2.80844 0.207031H1.89397V0.231451C2.3004 0.727981 2.42233 1.3344 2.74747 2.6734L5.18606 14H5.73474L3.29615 2.63678C3.08547 1.83729 2.92261 1.02594 2.80844 0.207031ZM0.979499 0.207031H0V0.231451C0.894148 0.585534 1.33309 1.26521 1.68669 2.85655L4.09682 13.9959H4.64551L2.21911 2.78736C1.80049 0.841939 1.36154 0.483786 0.979499 0.207031ZM13.4407 0.207031C12.2864 0.882638 11.5995 2.1321 10.1608 5.22932L10.1974 5.24967C11.8597 2.1321 12.8066 0.890778 14.9526 0.243661V0.207031H13.4407ZM10.0795 5.16827L10.1161 5.19269C11.4817 1.97338 11.8393 1.07392 12.3961 0.231451V0.207031H11.2907V0.239591C11.4045 1.52976 10.9736 2.71817 10.0795 5.16827Z"
        fill="#2A6EBB" />
    </svg>
    <svg
      class="platform-logo"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      *ngIf="platform === 'booking'">
        <path
          d="M10.4324 17.2981L7.35882 17.2952V13.7521C7.35882 12.995 7.66343 12.601 8.33539 12.511H10.4324C11.9279 12.511 12.8953 13.42 12.8953 14.8913C12.8953 16.4024 11.9524 17.2967 10.4324 17.2981H10.4324ZM7.35882 7.74154V6.8089C7.35882 5.99285 7.71699 5.60474 8.50223 5.55457H10.0758C11.4243 5.55457 12.2325 6.33225 12.2325 7.6353C12.2325 8.62696 11.6784 9.78538 10.1247 9.78538H7.35882V7.74154ZM14.357 11.2773L13.8014 10.9763L14.2866 10.5763C14.8514 10.1085 15.7974 9.05638 15.7974 7.24128C15.7974 4.46108 13.5611 2.66811 10.1002 2.66811H6.15112V2.66663H5.7011C4.67555 2.70352 3.85359 3.50778 3.84287 4.5024V20.2776H10.1783C14.0249 20.2776 16.5076 18.2588 16.5076 15.1318C16.5076 13.448 15.7056 12.0092 14.357 11.2773Z"
          fill="#0C3B7C" />
        <path
          d="M18.1583 18.0986C18.1583 16.8935 19.1664 15.9186 20.4086 15.9186C21.6538 15.9186 22.6667 16.8935 22.6667 18.0986C22.6667 19.3022 21.6538 20.2786 20.4085 20.2786C19.1664 20.2786 18.1583 19.3022 18.1583 18.0986Z"
          fill="#00AFF1" />
    </svg>
    <img src="/assets/images/connected-accounts/agoda.svg" alt="Agoda Logo" class="platform-logo" *ngIf="platform === 'agoda'" />

    <div class="success-separator"></div>
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.8334 12.0035V13.0002C23.8321 15.3363 23.0756 17.6094 21.6769 19.4805C20.2781 21.3516 18.312 22.7204 16.0717 23.3827C13.8315 24.0451 11.4371 23.9656 9.24576 23.156C7.0544 22.3464 5.18346 20.8501 3.91196 18.8903C2.64045 16.9305 2.03652 14.6122 2.19023 12.2812C2.34394 9.95012 3.24706 7.7312 4.76488 5.95534C6.28271 4.17948 8.33393 2.94184 10.6126 2.427C12.8913 1.91216 15.2754 2.14771 17.4093 3.09851"
        stroke="#47C693"
        stroke-width="1.95"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M23.8333 4.3335L13 15.1777L9.75 11.9277"
        stroke="#47C693"
        stroke-width="1.95"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>

    <div class="success-separator"></div>

    <svg width="41" height="55" viewBox="0 0 41 55" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.5 41.6931C31.8218 41.6931 41 32.496 41 21.1507C41 9.80552 31.8218 0.608398 20.5 0.608398C9.17816 0.608398 0 9.80552 0 21.1507C0 32.496 9.17816 41.6931 20.5 41.6931ZM20.5 33.4764C27.2931 33.4764 32.8 27.9581 32.8 21.151C32.8 14.3439 27.2931 8.8256 20.5 8.8256C13.7069 8.8256 8.2 14.3439 8.2 21.151C8.2 27.9581 13.7069 33.4764 20.5 33.4764ZM28.7784 45.8445H12.3454C10.0765 45.8445 8.23715 47.6895 8.23715 49.9654C8.23715 52.2413 10.0765 54.0863 12.3454 54.0863H28.7784C31.0474 54.0863 32.8867 52.2413 32.8867 49.9654C32.8867 47.6895 31.0474 45.8445 28.7784 45.8445Z"
        fill="#ED3C6A" />
    </svg>
  </section>

  <section fxLayout="column" fxLayoutGap="20px">
    <h2>That's it!</h2>
    <span>You're done.</span>
  </section>

  <section fxLayout="column" fxLayoutGap="16px" fxFlexFill>
    <sbnb-completion-box
      heading="Connect another account"
      description="You can connect as many accounts as you wish."
      buttonLabel="Connect"
      [routerLink]="['/accounts']"></sbnb-completion-box>
  </section>

  <section style="width: 100%">
    <button mat-flat-button [ngClass.lt-md]="{ fw: true }" [routerLink]="['/properties/segments/default']">
      Thanks, I'm finished for now
    </button>
  </section>
</div>
